import React, {
  useCallback, useContext, useMemo,
} from 'react'
import { LinkWithText, CPButton } from '@usap/widgets'
import {
  Box, MediaBox,
} from '@usap/uicomponents'
import {css} from 'styled-components';
import { LocalContext } from '../../helpers/useLocalContext'
import { GTM } from '../../helpers'
import homeIDs from '../../../config/homeIds'
import SectionTitle from './SectionTitle'
import { useCartContext } from '../../contexts/cart.context'
import { useVehicleContext } from '../../contexts/vehicle.context'
import PageTypeIdentifier from '../../helpers/PageTypeIdentifier';

export default function PopularParts(props) {
  const {
    dynamicApiData,
    apiDetails: {
      props: { sectionName },
    },
  } = props
  const parts = dynamicApiData

  const { localContext } = useContext(LocalContext)
  const { Link } = localContext

  const cartData = useCartContext()

  const vehicleState = useVehicleContext()
  const vehicleDB = useMemo(() => (vehicleState && vehicleState.vehicleDB) || [], [vehicleState])

  const isEmptyCart = __BROWSER__
    && window.location.pathname.indexOf('/cart') > -1
    && cartData.cartDB
    && cartData.cartDB.cartQuantity > 0

  const handleClick = useCallback(text => {
    PageTypeIdentifier.part()
    const { shopByPopularParts } = GTM
    shopByPopularParts(text)
  }, [])

  if (!parts || !Object.keys(parts).length) return ''
  if (isEmptyCart) return ''

  return (
    <MediaBox
      id={homeIDs.popParts}
      width="1248px"
      margin={{ horizontal: 'auto', vertical: '0px' }}
      pad="small"
      large={css`${({ theme }) => theme.shortcuts.padding('large', 0, 'large', 0)}`}
    >
      <SectionTitle
        id={homeIDs.popPartHeader}
        title={sectionName}
      />

      <LinkWithText
        gridId={homeIDs.popPartsGrid}
        elementId={homeIDs.popPart}
        data={parts}
        Link={Link}
        skip={vehicleDB.length === 0}
        handleClick={handleClick}
      />

      <Box
        id={homeIDs.seeAllPopParts}
        align="center"
        pad={{ vertical: 'medium' }}
      >
        <Link to="/parts">
          <CPButton
            id={homeIDs.seeAllPopPartsBtn}
            textLink="See All Parts"
          />
        </Link>
      </Box>
    </MediaBox>
  )
}
